import { ItemSource, SourceSection } from '../models/product/source-section.model';
import { wishlistItems } from "@sgm-frontend/core";

// Wishlist
export interface WishlistInput extends ItemSource {
  product_variant_id: string;
}
export interface RemoveWishlistInput {
  wishlist_ids_to_remove_from: any;
}

// Wishlist Category
export interface CreateWishlistCategoryInput {
  customerId: number;
  name: string;
  isDefault: boolean;
}

export interface UpdateWishlistCategoryInput {
  id?: string;
  name: string;
}

export interface SetDefaultWishlistCategoryInput {
  id: string;
  customerId?: number;
}

export interface MoveToWishlistCategoryInput {
  sourceSection?: SourceSection | null;
  productId: string;
  fromCategoryId: string;
  toCategoryId: string;
  mode: 'copy' | 'move' | 'remove';
}
export interface WishlistProduct {
  id: string;
  name: string;
  is_default: boolean;
  pagination?: WishListPagination;
  product?: wishlistItems[] | [];
}
export interface ProductToMove {
  sourceSection?: SourceSection | null;
  productId: string;
  productCategoryId?: string | '';
  mode: 'copy' | 'move' | 'delete' | 'remove';
}

export interface WishListPagination {
  total_records: number;
  total_pages: number;
  limit: number;
  page: number;
}
